import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, TextField, InputAdornment } from '@mui/material';

// const VisuallyHiddenInput = styled('input')({
//   clip: 'rect(0 0 0 0)',
//   clipPath: 'inset(50%)',
//   height: 1,
//   overflow: 'hidden',
//   position: 'absolute',
//   bottom: 0,
//   left: 0,
//   whiteSpace: 'nowrap',
//   width: 1,
// });

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
    borderRadius: '100px',
    '& fieldset': {
      borderColor: '#DDDDDD',
    },
    '&:hover fieldset': {
      borderColor: '#DDDDDD',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#5E17EB',
    },
  },
  '& .MuiInputBase-input': {
    padding: '15px 20px',
    color: '#666666',
    fontSize: '14px',
    fontWeight: 400,
    cursor: 'pointer',
  },
}));

const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 16L12 8" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 11L12 8L15 11" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 18H16" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CustomFileUpload = ({
  value,
  onChange,
  error,
  helperText,
  accept = "*",
  maxSize = 5242880,
  placeholder = "PDF, PNG, Jpeg, etc--"
}) => {
  const handleClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = (e) => {
      if (e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (file.size > maxSize) {
          alert(`File size should not exceed ${maxSize/1048576}MB`);
          return;
        }
        onChange({ target: { value: file } });
      }
    };
    input.click();
  };

  return (
    <Box sx={{ width: '100%' }}>
      <StyledTextField
        fullWidth
        placeholder={placeholder}
        value={value ? value.name : ''}
        onClick={handleClick}
        error={error}
        helperText={helperText}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
              <UploadIcon />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};